import _ from 'lodash'
import React, { Component } from 'react';
import { Container, Header, Button, Icon, Divider, Form, Loader, Segment, Dimmer, FormField, FormSelect, Checkbox, Image, Grid, Popup } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import {YouTubeLinks} from './info/YouTubeLinks.js';

import {summaries} from './info/summaries.js';
import {categories} from './info/categories.js';
import { FeaturedVideos } from './Helpers.js';
// import RecordingStorageHook from './RecordingStorageHook.js';
import { API_URL, WEB_URL } from '../App.js';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import ReactGA from "react-ga4";
import { customFontFam3, customTitleFontFam3, customFirefoxTitleFontFam } from './constants/constants.js';
import { ReactMediaRecorder } from "react-media-recorder";
import axios from 'axios';
import ReCAPTCHA from "react-google-recaptcha";
import Mirt from 'react-mirt';
import 'react-mirt/dist/css/react-mirt.css';
import Dropzone from 'react-dropzone'

var toWav = require('audiobuffer-to-wav')
var lamejs = require("lamejs");

// var xhr = require('xhr')

ReactGA.initialize("G-JZB9CXH4GJ")
// const categories = _.times(6, (i) => (
//   <Grid.Column key={i}>
//   	<div>
// 	    <Image src='/images/categories1.jpg' />
// 	    <h3 className='yugtun'>Ellavut</h3>
// 	    Weather, Climate
// 	  </div>
//   </Grid.Column>
// ))

// const keywords = _.times(6, (i) => (
//   <Grid.Column key={i}>
//   	<Button basic color='blue' size='mini'>Yugtun<br /><em>inYup'ik</em></Button>
//   </Grid.Column>
// ))

let customFontFam = customFontFam3
let customTitleFontFam = customTitleFontFam3
let customFontFam2 = {fontFamily:customTitleFontFam3}
let letterbutton = {fontFamily:customFontFam3,paddingTop:'10px',paddingBottom:'10px',paddingRight:'14px',paddingLeft:'14px',fontSize:'16px'}
const isFirefox = typeof InstallTrigger !== 'undefined';

if (isFirefox) {
  customFontFam = customFirefoxTitleFontFam
  customTitleFontFam = customFirefoxTitleFontFam
  customFontFam2 = {fontFamily:customFirefoxTitleFontFam}
  letterbutton = {fontFamily:customFirefoxTitleFontFam,paddingTop:'10px',paddingBottom:'10px',paddingRight:'14px',paddingLeft:'14px',fontSize:'16px'}
}

const AUDIO_CONFIG = {
    MP3_BITRATE: 192, // Increased from 128 for better quality
    CHUNK_SIZE: 4096, // Larger chunk size for better performance
    MAX_DURATION: 3600, // Maximum duration in seconds (1 hour)
    SAMPLE_RATE: 44100, // Standard sample rate
};

const genderOptions = [
  { key: 'm', text: 'Male', value: 'male' },
  { key: 'f', text: 'Female', value: 'female' },
  { key: 'o', text: 'Other', value: 'other' },
]

const nameVisibleOptions = [
  { key: 'v', text: 'Visible', value: 'visible' },
  { key: 'h', text: 'Hidden', value: 'hidden' },
]

const ageOptions = [
  { key: '0', text: '0-17', value: '0' },
  { key: '18', text: '18-29', value: '18' },
  { key: '30', text: '30-39', value: '30' },
]


class Recorder extends Component {
	constructor(props) {
		super(props);
		this.state = {
			// show: false,
			// showAllElders: false,
			// categoriesDisplayed: ['1','2','3','4','5','6'],
			// featuredVideoIDs:['3TIkchKpXqY','F_bWrmqQB74',],
			// featuredVideoIDs2:['XcMTNy-xdF4','E6h9Cryzk3M',],
			// featuredZooms:['sS4vCvvOj8M','r78afbyVauw','kGCA7_Gc2ys','UbhmhRJClhg','NaYBwnGnA_0','tNLboGKVYhY'],
			// // eldersList: [],
			// showMoreVideos:false,
			recordedBlob:[],
			sending:false,
			retrievingRecording:false,
			// returnedTranscript:'',
			returnedTranscript:"",
			recaptchaAllowed:false,
			currentAudioFileToSave:[],
			start:0,
			current:0,
			end:0,
			fileLoaded:false,
		}
	}

	// componentDidMount() {
	// 	let eldersList = []
	// 	Object.keys(categories).map((k) => {
	// 		if (k.includes('23.')) {
	// 			eldersList.push(k)
	// 		}
	// 	})
	// 	this.setState({eldersList:eldersList})
	// }


	sendFileFromBlobUrl = async (blob) => {
		const audioBlob = await fetch(blob).then((r) => r.blob());
		const audioFile = new File([audioBlob], 'voice.wav', { type: 'audio/wav' });
		this.sendRecordingForASR(audioFile)
	}

	sendRecordingForASR = (audioFile) => {
		this.setState({retrievingRecording:true})
		console.log(audioFile)
		const formData = new FormData(); // preparing to send to the server
    formData.append('file', audioFile);  // preparing to send to the server
    axios
      .post(API_URL + "yugtunASR", formData)
      .then(response => {
      	console.log(response)
      	// if (response.data) {
      	this.setState({returnedTranscript:response.data.transcription, retrievingRecording:false})
      	// }
      })

	}

	// trimRecording = async () => {

	// 	let audioFile = this.state.currentAudioFileToSave
  //   const startTime = 0; // Start time in seconds
  //   const endTime = 1; // End time in seconds

  //   const audioContext = new (window.AudioContext || window.webkitAudioContext)();
  //   const fileBuffer = await audioFile.arrayBuffer();
  //   const audioBuffer = await audioContext.decodeAudioData(fileBuffer);

  //   // Trim the audio buffer
  //   const trimmedBuffer = this.trimAudioBuffer(audioContext, audioBuffer, startTime, endTime);

  //   // Create a Blob from the trimmed buffer
  //   const trimmedAudioBlob = await this.createBlobFromAudioBuffer(trimmedBuffer);

  //   const newAudioFile = new File([trimmedAudioBlob], 'temp.wav', { type: 'audio/wav' });

  //   this.setState({currentAudioFileToSave:newAudioFile})
  //   // // Create an <audio> element to play the trimmed audio
  //   // const audioElement = document.createElement('audio');
  //   // audioElement.controls = true;
  //   // const audioUrl = URL.createObjectURL(trimmedAudioBlob);
  //   // audioElement.src = audioUrl;

  //   // document.body.appendChild(audioElement);

	// }

	// trimAudioBuffer = (audioContext, buffer, startTime, endTime) => {
	//     const sampleRate = buffer.sampleRate;
	//     const startFrame = startTime * sampleRate;
	//     const endFrame = endTime * sampleRate;
	//     const duration = endTime - startTime;
	//     const channels = buffer.numberOfChannels;

	//     // Create a new AudioBuffer for the trimmed audio
	//     const trimmedBuffer = audioContext.createBuffer(
	//         channels,
	//         (endFrame - startFrame),
	//         sampleRate
	//     );

	//     for (let channel = 0; channel < channels; channel++) {
	//         const sourceData = buffer.getChannelData(channel).subarray(startFrame, endFrame);
	//         trimmedBuffer.getChannelData(channel).set(sourceData);
	//     }

	//     return trimmedBuffer;
	// }

		trimAudio = async () => {
				let startTime = this.state.timeRange.start/1000
				let endTime = this.state.timeRange.end/1000

				// let startTime = 0
				// let endTime = 1

				// console.log(startTime,endTime)
				var bufferToWav = require('../')
				const arrayBuffer = await this.state.currentAudioFileToSave.arrayBuffer()
				// console.log(arrayBuffer)
				var audioContext = new (window.AudioContext || window.webkitAudioContext)()
				var audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
        const sampleRate = audioBuffer.sampleRate;
        const startOffset = Math.floor(startTime * sampleRate);
        const endOffset = Math.floor(endTime * sampleRate);
        const length = endOffset - startOffset;

        // console.log(audioBuffer.numberOfChannels,length,sampleRate)
        // Process in chunks to avoid memory issues
        const chunkSize = AUDIO_CONFIG.CHUNK_SIZE;
        const trimmedBuffer = audioContext.createBuffer(
            audioBuffer.numberOfChannels,
            length,
            sampleRate
        );

        for (let channel = 0; channel < audioBuffer.numberOfChannels; channel++) {
            const channelData = audioBuffer.getChannelData(channel);
            for (let i = 0; i < length; i += chunkSize) {
                const currentChunkSize = Math.min(chunkSize, length - i);
                const chunk = channelData.slice(startOffset + i, startOffset + i + currentChunkSize);
                trimmedBuffer.copyToChannel(chunk, channel, i);

                // Allow UI to update and prevent blocking
                if (i % (chunkSize * 4) === 0) {
                    await new Promise(resolve => setTimeout(resolve, 0));
                    // setButtonLoading(true, `Trimming... ${Math.round((i / length) * 100)}%`);
                }
            }
        }


			const mp3Blob = await this.convertToMp3(trimmedBuffer);
			// let mp3file = new File([mp3Blob], 'recording.mp3');

			// const audioBlob2 = await fetch(mp3Blob).then((r) => r.blob());
			const audioFile2 = new File([mp3Blob], 'voice.mp3', { type: 'audio/mp3' });


      console.log(audioFile2)
			// arrayBuffer = encodeWAV(trimmedBuffer, [opt])
		  // audioContext.decodeAudioData(trimmedBuffer, function (buffer) {
		  //   // encode AudioBuffer to WAV
		  //   var wav = toWav(buffer)

		  //   console.log(wav)
		  //   // this.setState({currentAudioFileToSave:wav})

		  //   // do something with the WAV ArrayBuffer ...
		  // })

      // var wav = bufferToWav(trimmedBuffer)
      if (audioBuffer) {
          audioBuffer = null;
      }
      if (audioContext && audioContext.state !== 'closed') {
          audioContext.close();
          audioContext = null;
      }
      // Clear any object URLs
      // if (elements.audioPlayer.src) {
      //     URL.revokeObjectURL(elements.audioPlayer.src);
      // }
      // if (elements.previewPlayer.src) {
      //     URL.revokeObjectURL(elements.previewPlayer.src);
      // }

      this.setState({currentAudioFileToSave:audioFile2})
        // return trimmedBuffer;
    }

		// cleanup = () => {
    //     if (audioBuffer) {
    //         audioBuffer = null;
    //     }
    //     if (audioContext && audioContext.state !== 'closed') {
    //         audioContext.close();
    //         audioContext = null;
    //     }
    //     // Clear any object URLs
    //     if (elements.audioPlayer.src) {
    //         URL.revokeObjectURL(elements.audioPlayer.src);
    //     }
    //     if (elements.previewPlayer.src) {
    //         URL.revokeObjectURL(elements.previewPlayer.src);
    //     }
    // }

    // window.addEventListener('unload', cleanup);

    convertToMp3 = async (audioBuffer) => {
        if (!audioBuffer || !audioBuffer.numberOfChannels) {
            throw new Error('Invalid audio buffer');
        }

        const channels = audioBuffer.numberOfChannels;
        const sampleRate = audioBuffer.sampleRate;

        // Initialize MP3 encoder with better quality settings
        const mp3encoder = new lamejs.Mp3Encoder(
            channels,
            sampleRate,
            AUDIO_CONFIG.MP3_BITRATE
        );

        const mp3Data = [];
        const sampleBlockSize = AUDIO_CONFIG.CHUNK_SIZE;
        const numSamples = audioBuffer.length;
        let processedSamples = 0;

        // Get audio data
        const channelData = [];
        for (let channel = 0; channel < channels; channel++) {
            channelData[channel] = audioBuffer.getChannelData(channel);
        }

        try {
            for (let i = 0; i < numSamples; i += sampleBlockSize) {
                const currentBlockSize = Math.min(sampleBlockSize, numSamples - i);
                const leftInt16 = new Int16Array(currentBlockSize);
                const rightInt16 = channels > 1 ? new Int16Array(currentBlockSize) : null;

                // Convert samples to Int16
                for (let j = 0; j < currentBlockSize; j++) {
                    // Improved conversion with dithering to reduce quantization noise
                    const dither = (Math.random() * 2 - 1) * 0.5;
                    leftInt16[j] = Math.max(-32768, Math.min(32767,
                        Math.round(channelData[0][i + j] * 32767 + dither)));

                    if (channels > 1) {
                        rightInt16[j] = Math.max(-32768, Math.min(32767,
                            Math.round(channelData[1][i + j] * 32767 + dither)));
                    }
                }

                // Encode the block
                const mp3buf = channels > 1
                    ? mp3encoder.encodeBuffer(leftInt16, rightInt16)
                    : mp3encoder.encodeBuffer(leftInt16);

                if (mp3buf && mp3buf.length > 0) {
                    mp3Data.push(mp3buf);
                }

                processedSamples += currentBlockSize;

                // Update progress and allow UI to update
                if (i % (sampleBlockSize * 4) === 0) {
                    await new Promise(resolve => setTimeout(resolve, 0));
                    const progress = Math.round((processedSamples / numSamples) * 100);
                    // setButtonLoading(true, `Converting... ${progress}%`);
                }
            }

            const mp3buf = mp3encoder.flush();
            if (mp3buf && mp3buf.length > 0) {
                mp3Data.push(mp3buf);
            }

            return new Blob(mp3Data, { type: 'audio/mp3' });

        } catch (error) {
            console.error('MP3 conversion error:', error);
            throw new Error('Failed to convert audio to MP3: ' + error.message);
        }
    }


  createBlobFromAudioBuffer = (audioBuffer) => {
      return new Promise((resolve) => {
          const audioContext = new (window.AudioContext || window.webkitAudioContext)();
          const audioBufferSource = audioContext.createBufferSource();
          audioBufferSource.buffer = audioBuffer;

          audioBufferSource.connect(audioContext.destination);

          audioBufferSource.onended = () => {
              const audioData = audioBuffer.getChannelData(0);
              const audioBlob = new Blob([audioData], { type: 'audio/wav' });
              resolve(audioBlob);
          };

          audioBufferSource.start();
          audioBufferSource.stop(audioContext.currentTime + audioBuffer.duration);
      });
  }

	seeRecording = async (recording, blob) => {
		console.log(recording, blob)
		const audioBlob = await fetch(recording).then((r) => r.blob());
		const audioFile = new File([blob], 'voice.wav', { type: 'audio/wav' });
		this.setState({currentAudioFileToSave:audioFile})
	}

	sendRecordingToSave = async (recording) => {
		console.log('SAVEsent',recording)
		this.setState({sendingRecording:true})
		const audioBlob = await fetch(recording).then((r) => r.blob());
		const audioFile = new File([audioBlob], 'voice.mp3', { type: 'audio/mp3' });
		const formData = new FormData(); // preparing to send to the server
    formData.append('file', audioFile);  // preparing to send to the server
		formData.append("data", JSON.stringify({"name": "egalaaq","sentence":"qaill pia?","age": "30-29", "validated": "no"}));

    axios
      .post(API_URL + "yugtunCrowdsource", formData)
      .then(response => {
      	console.log(response)
      	// if (response.data) {
      	// this.setState({returnedTranscript:response.data.transcription, retrievingRecording:false})
      	// }
      })
	}

	render() {
		console.log(this.state)
		let showLargerTable = window.innerWidth >= 480
		return (
			<div className='home'>
				<div className='yugtatun'>ASR Tool</div>

				<Dropzone onDrop={acceptedFiles => {this.setState({fileLoaded:true,currentAudioFileToSave:acceptedFiles[0]})}}>
				  {({getRootProps, getInputProps, acceptedFiles}) => (
				    <section>
				      <div style={{display:'flex',justifyContent:'center'}} {...getRootProps()}>
				        <input {...getInputProps()} />
				        <Button size='large'>Drag 'n' drop some files here, or click to select files</Button>
				      </div>
        			{this.state.fileLoaded ?
	        			<div>
					        <div>
		        				<Mirt onChange={(timeRange) => {this.setState({timeRange:timeRange})}} file={this.state.currentAudioFileToSave} />
					        	<Button onClick={()=>{this.trimAudio()}}>Trim Recording</Button>
					          <Button disabled={this.state.retrievingRecording} basic onClick={()=>{this.setState({currentAudioFileToSave:[]})}}>{'Redo'}</Button>
									  <Button disabled={this.state.retrievingRecording || this.state.returnedTranscript.length > 0} onClick={()=>this.sendRecordingForASR(acceptedFiles[0])}>{'Submit'}</Button>
					        </div>
					        <div style={{display:'flex',justifyContent:'center',margin:20}}>
						        {this.state.retrievingRecording ?
									    <Segment>
									      <Dimmer active inverted>
									        <Loader size='small'>Preparing Transcript</Loader>
									      </Dimmer>
									      <Image src='https://react.semantic-ui.com/images/wireframe/paragraph.png' />
									    </Segment>
									    :
									    (this.state.returnedTranscript.length > 0 ?
										    <Segment>
										      {this.state.returnedTranscript}
										    </Segment>
										    :
										    null
										 	)
									  }
									</div>
								</div>
	        			:
	        			null
	        		}
				    </section>
				  )}
				</Dropzone>			

		    <ReactMediaRecorder
		      audio
		      onStop={this.seeRecording}
		      render={({ status, startRecording, stopRecording, mediaBlobUrl, clearBlobUrl }) => (
		        <div style={{textAlign:'center'}}>
		          <div>
				      </div>
		        	{mediaBlobUrl !== undefined ?
		        		<div style={{textAlign:'center',}}>
		        			{'name' in this.state.currentAudioFileToSave ?
		        				<div>
		        					<Mirt onChange={(timeRange) => {this.setState({timeRange:timeRange})}} file={this.state.currentAudioFileToSave} />
							        <div>
							        	<Button onClick={()=>{this.trimAudio()}}>Trim Recording</Button>
							          <Button disabled={this.state.retrievingRecording} basic onClick={clearBlobUrl}>{'Redo'}</Button>
											  <Button disabled={this.state.retrievingRecording || this.state.returnedTranscript.length > 0} onClick={()=>{this.sendRecordingForASR(this.state.currentAudioFileToSave)}}>{'Submit'}</Button>
							        </div>
							      </div>
			        			:
			        			null
			        		}

					        <div style={{display:'flex',justifyContent:'center',margin:20}}>
						        {this.state.retrievingRecording ?
									    <Segment>
									      <Dimmer active inverted>
									        <Loader size='small'>Preparing Transcript</Loader>
									      </Dimmer>
									      <Image src='https://react.semantic-ui.com/images/wireframe/paragraph.png' />
									    </Segment>
									    :
									    (this.state.returnedTranscript.length > 0 ?
										    <Segment>
										      {this.state.returnedTranscript}
										    </Segment>
										    :
										    null
										 	)
									  }
									</div>
					      </div>
				        :
			          (status == 'recording' ?
				          <Icon size='big' color='red' style={{cursor:'pointer'}} circular name='stop' onClick={stopRecording} />
				          :
				          <Icon size='big' color='grey' style={{cursor:'pointer'}} circular name='microphone' onClick={startRecording} />
				        )
				      }	      
		        </div>
		      )}
		    />

				<Divider />
				<div className='yugtatun'>Crowdsourcing</div>

		    <ReactMediaRecorder
		      audio
		      onStop={this.seeRecording}
		      render={({ status, startRecording, stopRecording, mediaBlobUrl, clearBlobUrl }) => (
		        <div style={{textAlign:'center'}}>
				      <div style={{fontSize:'20px',margin:'25px'}}>{"akutamek ner'uq"}</div>
		          <div>
				      </div>
		        	{mediaBlobUrl !== undefined?
		        		<div style={{textAlign:'center',}}>
		        			{'name' in this.state.currentAudioFileToSave ?
		        				<div>
		        					<Mirt onChange={(timeRange) => {this.setState({timeRange:timeRange})}} file={this.state.currentAudioFileToSave} />
							        <div>
							        	<Button onClick={()=>{this.trimAudio()}}>Trim Recording</Button>
							          <Button disabled={this.state.retrievingRecording} basic onClick={clearBlobUrl}>{'Redo'}</Button>
							        </div>
							      </div>
			        			:
			        			null
			        		}
					        <div style={{display:'flex',justifyContent:'center',marginTop:'20px'}}>
									  <Form loading={this.state.sendingRecording} style={{width:'350px'}}>
									    <FormField>
									      <label>Name</label>
									      <input placeholder='Name' />
									    </FormField>
									    <FormSelect label='Age' options={ageOptions} placeholder='0-17' />
									    <FormSelect label='Name Visibility' options={nameVisibleOptions} placeholder='Visible' />
									    <FormSelect label='Gender' options={genderOptions} placeholder='Male' />
									    <FormField>
									      <Checkbox label='I agree to donating this clip for use in www.yugtun.com' />
									    </FormField>
											<ReCAPTCHA
												  style={{margin:22}}
											    sitekey="6LcjLeMrAAAAAAc3X2tUrlQ66G9H7X2DImvTK7B6"
											    onChange={()=>{this.setState({recaptchaAllowed:true})}}
											    onErrored={()=>{this.setState({recaptchaAllowed:false})}}
											    onExpired={()=>{this.setState({recaptchaAllowed:false})}}
											  />
									    <Button  onClick={()=>this.sendRecordingToSave(mediaBlobUrl)}>{'Submit'}</Button>
									  </Form>
									</div>
					      </div>
				        :
			          (status == 'recording' ?
				          <Icon size='big' color='red' style={{cursor:'pointer'}} circular name='stop' onClick={stopRecording} />
				          :
				          <Icon size='big' color='grey' style={{cursor:'pointer'}} circular name='microphone' onClick={startRecording} />
				        )
				      }
		        </div>
		      )}
		    />
			</div>
		);
	}
}
export default Recorder;